import {createScriptIn} from './ui_utils/DomUtils'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {ClientUserState} from './ClientUserState'

export class ValueImpressionLoader {
    private static initialized = false
    static init() {
        if(this.initialized) return

        if(UIUtilsEjsVariables.vliPublicKey == '') return
        if(UIUtilsEjsVariables.vliAdvKey == '') return
        if(window['vitag'] == undefined) return // only set on pages where ads can be displayed
        if(window.location.hostname === 'localhost') return
        if(UIUtilsEjsVariables.isUserOnDiscord) return
        if(UIUtilsEjsVariables.isUserOnMobile && UIUtilsEjsVariables.shouldHideAdsOnMobile) return
        if(ClientUserState.isStale()) return
        if(ClientUserState.userState?.items.hideAds()) return
        window['hashString'] = ClientUserState.userState?.vliHash

        createScriptIn(document.body, UIUtilsEjsVariables.vliPublicKey)
        createScriptIn(document.body, UIUtilsEjsVariables.vliAdvKey)
        createScriptIn(document.body, '//cdn.jsdelivr.net/gh/vli-platform/adb-analytics@77bebb/v1.0.min.js')

        document.querySelectorAll('.remove_ads_button_in_game')
            .forEach((element) => element.classList.remove('hidden'))
        document.querySelectorAll('.vli_page_vertical_ad')
            .forEach((element) => element.classList.remove('hidden'))
        document.querySelectorAll('.main_page_ad_300x100')
            .forEach((element) => element.classList.remove('hidden'))
        document.querySelectorAll('.main_page_ad_300x250')
            .forEach((element) => element.classList.remove('hidden'))
        document.querySelectorAll('.adsbyvli')
            .forEach((element) => element.classList.remove('hidden'))
        this.initialized = true
    }
}
